import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "../../components/Seo";

import { BookOpen, KeyRound, MessageCircle, Pencil } from "lucide-react";
import Ico from "../../components/Ico";
const SHORTCUTS = [
  { to: "/#curriculum", icon: BookOpen, label: "The curriculum", note: "What each age group learns" },
  { to: "/enroll", icon: Pencil, label: "Enrol a child", note: "Choose an age group and start" },
  { to: "/login", icon: KeyRound, label: "Sign in", note: "Parents, learners and staff" },
  { to: "/contact", icon: MessageCircle, label: "Talk to us", note: "Email or WhatsApp" },
];

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative overflow-hidden bg-paper">
      <Seo title="Page not found" description="This page doesn't exist." path="/404" noindex />
      <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-gold-100 blur-2xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-20 h-80 w-80 rounded-full bg-brand-100 blur-2xl" />

      <div className="relative mx-auto flex min-h-[72vh] max-w-3xl flex-col items-center justify-center px-4 py-16 text-center">
        <p className="inline-flex items-center gap-2 rounded-full border border-gold-300 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-gold-500">
          Error 404
        </p>
        <h1 className="mt-5 text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
          This page went off the map
        </h1>
        <p className="mt-4 max-w-xl text-base leading-7 text-ink-mute sm:text-lg">
          The link may be old, or the address has a typo. Every good engineer debugs, so let's get you somewhere useful.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="rounded-2xl bg-brand-600 px-7 py-3 text-[15px] font-bold text-white shadow-soft transition hover:bg-brand-700"
          >
            Back to home
          </Link>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="rounded-2xl border border-[#cdd4e2] bg-white px-7 py-3 text-[15px] font-bold text-ink transition hover:border-brand-600"
          >
            Go back
          </button>
        </div>

        <div className="mt-12 grid w-full gap-3 sm:grid-cols-2">
          {SHORTCUTS.map((s) => (
            <Link
              key={s.to}
              to={s.to}
              className="group flex items-center gap-4 rounded-[22px] border border-[#e5e8ef] bg-white p-4 text-left transition hover:-translate-y-0.5 hover:border-brand-300 hover:shadow-soft"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#f1f3f8] text-xl"><Ico icon={s.icon} /></span>
              <span>
                <span className="block text-[15px] font-bold text-ink group-hover:text-brand-600">{s.label}</span>
                <span className="block text-sm text-ink-mute">{s.note}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
